var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNearme(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1254 13.7996L3.35039 11.1746C3.18372 11.1079 3.04622 10.9913 2.93789 10.8246C2.82956 10.6579 2.77539 10.4746 2.77539 10.2746C2.77539 10.0746 2.82956 9.89961 2.93789 9.74961C3.04622 9.59961 3.18372 9.49128 3.35039 9.42461L19.4504 3.34961C19.6337 3.26628 19.8046 3.24961 19.9629 3.29961C20.1212 3.34961 20.2587 3.43294 20.3754 3.54961C20.4921 3.66628 20.5712 3.80378 20.6129 3.96211C20.6546 4.12044 20.6421 4.28294 20.5754 4.44961L14.4754 20.5496C14.4254 20.7496 14.3171 20.8996 14.1504 20.9996C13.9837 21.0996 13.8087 21.1496 13.6254 21.1496C13.4421 21.1496 13.2671 21.0996 13.1004 20.9996C12.9337 20.8996 12.8171 20.7496 12.7504 20.5496L10.1254 13.7996Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNearme);
export default __webpack_public_path__ + "static/media/nearme.09bce7e1c8ef0db727ee84538fe51179.svg";
export { ForwardRef as ReactComponent };